module.exports = __webpack_public_path__ + "static/logoSerratekNegro-c2cc578b7d17ba04d6dca9bc7d61e690.png";